"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDidUpdate = void 0;
const react_1 = require("react");
/* Triggers the received callback any time the deps change,
  not including first render (unlike React.useEffect) */
const useDidUpdate = (cb, deps) => {
    const isFirstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (!isFirstRender.current) {
            cb();
        }
        isFirstRender.current = false;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
};
exports.useDidUpdate = useDidUpdate;
//# sourceMappingURL=index.js.map